export function hasCompletedSignupQuestions(user) {
  return Boolean(
    user?.companyProfile?.onboarding?.completedAt ||
    user?.settings?.onboardingQuestionsCompleted
  );
}

export function needsSignupQuestions(user) {
  return Boolean(user?.settings?.onboardingQuestionsRequired) && !hasCompletedSignupQuestions(user);
}

export function mergeUserPreservingOnboarding(prev, next) {
  if (!next) return prev;
  if (!hasCompletedSignupQuestions(prev) || hasCompletedSignupQuestions(next)) {
    return next;
  }
  return {
    ...next,
    companyProfile: {
      ...(next.companyProfile || {}),
      onboarding: prev.companyProfile?.onboarding || next.companyProfile?.onboarding,
    },
    settings: {
      ...(next.settings || {}),
      onboardingQuestionsRequired: false,
      onboardingQuestionsCompleted: true,
    },
  };
}
